import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupComponent implements OnDestroy, OnInit {
  @Input() CdkOverlayOrigin: CdkOverlayOrigin;
  @Output() close = new EventEmitter<any>();
  @Output() open = new EventEmitter<any>();

  @ViewChild('dialog', { static: false }) dialog: ElementRef;
  @Input() isOpened = false;
  destroy$ = new Subject<any>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    const CdkOverlayOriginEl = this.CdkOverlayOrigin.elementRef.nativeElement;

    // open popup if mouse stopped in CdkOverlayOriginEl (for short time).
    // If user just quickly got over CdkOverlayOriginEl element - do not open
    // const open$ = Observable.fromEvent(CdkOverlayOriginEl, 'mouseenter')
    //   .filter(() => !this.isOpened)
    //   .switchMap(enterEvent =>
    //     Observable.fromEvent(document, 'mousemove')
    //       .startWith(enterEvent)
    //       .debounceTime(0)
    //       .filter(event => CdkOverlayOriginEl === event['target'])
    //   )
    //   .share();
    // open$
    //   .takeUntil(this.destroy$)
    //   .subscribe(() => { return; } );

    // close if mouse left the CdkOverlayOriginEl and dialog(after short delay)
    const close$ = Observable.fromEvent(document, 'mousemove')
      .debounceTime(0)
      .filter(() => this.isOpened)
      .filter(event => this.isMovedOutside(CdkOverlayOriginEl, this.dialog, event));

    close$
      .takeUntil(this.destroy$)
      //.switchMapTo(close$)
      .subscribe(() => {
        this.changeState(false);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  connectedOverlayDetach() {
    this.changeState(false);
  }

  private changeState(isOpened: boolean) {
    this.isOpened = isOpened;
    isOpened ? this.open.emit() : this.close.emit();
    this.changeDetectorRef.markForCheck();
  }

  private isMovedOutside(CdkOverlayOriginEl, dialog, event): boolean {
    return !(CdkOverlayOriginEl.contains(event['target']) || dialog.nativeElement.contains(event['target']));
  }
}
